import { render } from "./AstroLifePrompts.vue?vue&type=template&id=2c18feb6&scoped=true"
import script from "./AstroLifePrompts.vue?vue&type=script&lang=js"
export * from "./AstroLifePrompts.vue?vue&type=script&lang=js"

import "./AstroLifePrompts.vue?vue&type=style&index=0&id=2c18feb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c18feb6"]])

export default __exports__